module.exports = __webpack_public_path__ + "img/events.3895d4c8.jpg";